import PropTypes from 'prop-types'
import React from 'react'
import Media from 'react-media'
import { connect } from 'transfer/utils/p2p-connect'
import { routeTo } from 'transfer/utils/routeHelper'
import { paymentTypeUrlMap } from '../../index'
import {
  trackClickUnifiedSend,
  trackGuestReturnToPagePmtChoice,
} from '../../../../../utils/unified-send-analytics'
import { tracking } from '../../../../../../lib/analytics/mParticle'
import Events from '../../../../../../lib/analytics/eventTags'
import content from 'pp-react-l10n'
import { PaymentTypes } from '../alt-pay-styles'
import { mediaQueries } from 'transfer/styles'
import glamorous from 'glamorous'
import PurchaseProtection from '../../purchaseProtectionLink'
import * as UnifiedActions from 'transfer/actions/unified-actions'
import { ActionTypes as types } from '../../../../../constants'
import { PAYMENT_TYPE, MONEY_PAGE } from '../../../../../../../../lib/constants'
import { redirectToDolphin } from '../../../../../actions/unified-actions'
import * as ViewActions from '../../../../../actions/Actions'
import { handleInterstitialCipFlow } from '../../../../../utils/homeInfoUtils'
import {
  Radio,
  RadioGroup,
  Button,
  BodyText,
  CaptionText,
  HeadingText,
  Spot,
  SingleSelectionGroup,
  v2white,
  v2grey300,
} from '@paypalcorp/pp-react'

import { SIZE_MOBILE } from 'lib/styles/media-queries'
const { phoneLandscapeMax: phone640 } = mediaQueries
const i18nPaymentType = content('transfer/inc/paymentTypeChoices')

const IconWrapper = glamorous.div({
  marginBottom: '1rem',
})
const PaymentTypesToggle = glamorous(PaymentTypes)({
  maxWidth: '28rem',
  '& .personal-purchase-group label': {
    padding: '1rem',
    textAlign: 'left',
    border: `1px solid ${v2grey300}`,
    transition: 'initial',
    borderRadius: '0.75rem',
  },
  '& .personal-purchase-group label.checkedLabel': {
    '& .text-color': {
      color: v2white,
    },
  },
  '& .personal-purchase-group > div': {
    display: 'flex',
    flexFlow: 'inherit',
  },

  '& .footer-buttons': {
    textAlign: 'center',
  },
  '& .note-content': {
    marginTop: '1.5rem',
    [phone640]: {
      marginTop: '1.25rem',
    },
  },
  '& .continue-btn': {
    marginTop: '1.5rem',
    marginBottom: '2rem',
    [phone640]: {
      width: '19rem',
      marginTop: '1.25rem',
      marginBottom: '1.5rem',
    },
  },
})

const TitleText = glamorous.div({
  marginBottom: '0.25rem',
})

export class PaymentTypeChoice extends React.Component {
  state = {
    highlightPaymentType: this.props.highlightPaymentType, // [PERSONAL|PURCHASE]
    // currently, we will have the recommended badge by default for the purchase option
    recommendedPaymentType: this.props.recommendedPaymentType, // [PERSONAL|PURCHASE]
    whoPaysFee: this.props.whoPaysFee, // ['sellerPaysFee'|'senderPaysFee']
  }

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    flowType: PropTypes.string,
    handleClose: PropTypes.func,
    handleCloseForOtherFlow: PropTypes.func,
    isGuest: PropTypes.bool,
    hasSelectedFundingOption: PropTypes.bool,
    fee: PropTypes.string,
    whoPaysFee: PropTypes.string,
    overpanelType: PropTypes.string,
    highlightPaymentType: PropTypes.string,
    recommendedPaymentType: PropTypes.string,
    triggerSenderPhoneConfirmation: PropTypes.bool,
    amount: PropTypes.any,
    currencyCode: PropTypes.string,
    thumbnailUrl: PropTypes.string,
    displayName: PropTypes.string,
    recipient: PropTypes.string,
    payerId: PropTypes.string,
    isPurchase: PropTypes.bool,
    suggestedDesign: PropTypes.string,
    moneyPageOverPanel: PropTypes.string,
    isPersonalDisabled: PropTypes.bool,
    isPurchaseDisabled: PropTypes.bool,
  }

  url = null
  targetFlowType = this.props.flowType

  // we route on unmount because if we route immediately after dispatching the action to close the overpanel,
  // it's too fast and the overpanel stays attached to the DOM.. so we let the overpanel unmounting do the routing
  componentWillUnmount() {
    // Redirect to Dolphin Flow After Payment Type Selection if the user has no confirmed phone and falls in the treatment
    const {
      triggerSenderPhoneConfirmation,
      amount,
      currencyCode,
      payerId,
      recipient,
      displayName,
      thumbnailUrl,
    } = this.props
    if (
      this.props.flowType !== 'payRequest' &&
      triggerSenderPhoneConfirmation
    ) {
      const flowType = this.targetFlowType
      const data = {
        flowType,
        amount,
        currencyCode,
        payerId,
        recipient,
        displayName,
        thumbnailUrl,
      }
      this.props.dispatch(redirectToDolphin(data))
    } else if (this.url && this.url !== 'payRequest') {
      routeTo(this.url)
    }
  }

  handleCloseForOtherFlow = targetFlowType => {
    let shouldUpdateTransactionData = false

    if (this.props.flowType === 'payRequest') {
      const preFlowType = this.props.isPurchase ? 'buy' : 'send'
      if (preFlowType !== targetFlowType) {
        shouldUpdateTransactionData = true
      }
    } else if (targetFlowType && targetFlowType !== this.props.flowType) {
      shouldUpdateTransactionData = true
    }

    // don't do anything unless target flow is different from current
    if (shouldUpdateTransactionData) {
      shouldUpdateTransactionData = true
      this.targetFlowType = targetFlowType
      let pageAction
      if (this.props.isGuest) {
        pageAction =
          targetFlowType === PAYMENT_TYPE.PERSONAL
            ? 'guestSelectFF'
            : 'guestSelectGS'
      } else {
        pageAction =
          targetFlowType === PAYMENT_TYPE.PERSONAL ? 'selectFF' : 'selectGS'
      }

      trackClickUnifiedSend(pageAction)

      this.props.dispatch(
        UnifiedActions.changedPurchaseProtection({
          currentPurchaseProtection: targetFlowType === PAYMENT_TYPE.PURCHASE,
          changedPurchaseProtection: true,
        })
      )
      if (this.props.isGuest) {
        trackGuestReturnToPagePmtChoice(pageAction)
      }
    }
    this.props.handleCloseForOtherFlow(shouldUpdateTransactionData, {
      isPurchase: targetFlowType === PAYMENT_TYPE.PURCHASE,
    })
  }

  handlePaymentType = e => {
    this.setState({
      highlightPaymentType: e.target.value,
    })
  }

  handleFeeOption = e => {
    this.setState({
      whoPaysFee: e.target.value,
    })
    trackClickUnifiedSend(e.target.value)
    tracking(
      Events.p2p_payment_type_fee_payer_option_pressed({
        suggested_protection_design: this.props.suggestedDesign,
        fee_payer: e.target.value === 'sellerPaysFee' ? 'payee' : 'payer',
        protection_design: this.props.moneyPageOverPanel,
      })
    )
  }

  handleSubmit = e => {
    let targetFlowType =
      e.currentTarget.value === PAYMENT_TYPE.PURCHASE
        ? PAYMENT_TYPE.PURCHASE
        : PAYMENT_TYPE.PERSONAL
    let shouldUpdateTransactionData = false

    // the handleClose is closely coupled to send flow
    // this is hack for other flows so that we do not need to do the routing
    if (this.props.handleCloseForOtherFlow) {
      return this.handleCloseForOtherFlow(targetFlowType)
    }

    if (this.props.isPersonalDisabled && targetFlowType === 'PERSONAL') {
      return handleInterstitialCipFlow(
        targetFlowType === 'PURCHASE' ? 'buy' : 'send'
      )
    }
    if (this.props.isPurchaseDisabled && targetFlowType === 'PURCHASE') {
      return handleInterstitialCipFlow(
        targetFlowType === 'PURCHASE' ? 'buy' : 'send'
      )
    }

    const url =
      this.props.flowType !== 'payRequest'
        ? paymentTypeUrlMap[targetFlowType]
        : 'payRequest'

    if (this.props.flowType === 'payRequest') {
      const preFlowType = this.props.isPurchase ? 'buy' : 'send'
      if (preFlowType !== targetFlowType) {
        shouldUpdateTransactionData = true
      }
    } else if (targetFlowType && targetFlowType !== this.props.flowType) {
      shouldUpdateTransactionData = true
    }

    // don't do anything unless target flow is different from current
    if (shouldUpdateTransactionData) {
      this.url = url
      this.targetFlowType = targetFlowType
      shouldUpdateTransactionData = true
      let pageAction
      if (this.props.isGuest) {
        pageAction =
          targetFlowType === PAYMENT_TYPE.PERSONAL
            ? 'guestSelectFF'
            : 'guestSelectGS'
      } else {
        pageAction =
          targetFlowType === PAYMENT_TYPE.PERSONAL ? 'selectFF' : 'selectGS'
      }
      trackClickUnifiedSend(pageAction, {
        feePayer: this.state.whoPaysFee === 'sellerPaysFee' ? 'payee' : 'payer',
      })
    }

    this.props.dispatch({
      type: types.TRANSACTION.CHANGE_FEE_OPTION,
      data: {
        whoPaysFee: this.state.whoPaysFee,
      },
    })

    this.props.dispatch({
      type: types.TRANSACTION.CHANGE_HIGHLIGHTED_PAYMENT_TYPE,
      data: {
        highlightPaymentType: this.state.highlightPaymentType,
      },
    })

    this.props.dispatch(ViewActions.setPaymentTypeSelected(true))

    this.props.handleClose(shouldUpdateTransactionData, {
      isPurchase: targetFlowType === PAYMENT_TYPE.PURCHASE,
    })
  }

  render() {
    const { overpanelType } = this.props
    const { highlightPaymentType } = this.state

    const isPersonalHighlighted = highlightPaymentType === PAYMENT_TYPE.PERSONAL
    const isPurchaseHighlighted = highlightPaymentType === PAYMENT_TYPE.PURCHASE
    const isSomethingHighlighted =
      isPersonalHighlighted || isPurchaseHighlighted

    const isT10 = overpanelType === MONEY_PAGE.BUYER_FEES_REC_DEFAULT_WEB
    const isT11 = overpanelType === MONEY_PAGE.TWO_BUTTON_NON_DEFAULT_WEB
    const canChooseWhoPays = isT10 && isPurchaseHighlighted

    const shouldShowNote = isSomethingHighlighted && !canChooseWhoPays
    let noteContent = i18nPaymentType('purchaseProtection.tPBNote')
    if (isPurchaseHighlighted) {
      noteContent = i18nPaymentType('purchaseProtection.tPBRadioSellerPays')
    } else if (isT11) {
      noteContent = i18nPaymentType('purchaseProtection.tPBNote')
    }
    const personalLabel = (
      <Media query={`(max-width: ${SIZE_MOBILE}px)`}>
        {matches => (
          <div>
            <IconWrapper>
              <Spot name="personal-account" role="presentation" size="lg" />
            </IconWrapper>
            <BodyText as={TitleText} strong className="text-color">
              {i18nPaymentType('purchaseProtection.tPBSendTitle')}
            </BodyText>
            {matches ? (
              <CaptionText className="text-color">
                {i18nPaymentType('purchaseProtection.tPBSendDescription')}
              </CaptionText>
            ) : (
              <BodyText className="text-color">
                {i18nPaymentType('purchaseProtection.tPBSendDescription')}
              </BodyText>
            )}
          </div>
        )}
      </Media>
    )
    const purchaseLabel = (
      <Media query={`(max-width: ${SIZE_MOBILE}px)`}>
        {matches => (
          <div>
            <IconWrapper>
              <Spot name="insured" role="presentation" size="lg" />
            </IconWrapper>
            <BodyText as={TitleText} strong className="text-color">
              {i18nPaymentType('purchaseProtection.tPBBuyTitle')}
            </BodyText>
            {matches ? (
              <CaptionText className="text-color">
                {i18nPaymentType('purchaseProtection.tPBBuyDescription')}
              </CaptionText>
            ) : (
              <BodyText className="text-color">
                {i18nPaymentType('purchaseProtection.tPBBuyDescription')}
              </BodyText>
            )}
          </div>
        )}
      </Media>
    )
    return (
      <div data-nemo="t-parallel-buttons-variant">
        <PaymentTypesToggle tabIndex="-1">
          <HeadingText as="h2" size="sm">
            {i18nPaymentType(
              isT11
                ? 'purchaseProtection.t11Title'
                : 'purchaseProtection.tPBTitle'
            )}
          </HeadingText>
          <SingleSelectionGroup
            align="center"
            name="paymentType"
            label={i18nPaymentType('main.chooseAPaymentType')}
            hideLabel={true}
            onChange={this.handlePaymentType}
            className="personal-purchase-group"
            options={[
              {
                label: personalLabel,
                id: 'personalLabel',
                'data-testid': 'personal',
                value: PAYMENT_TYPE.PERSONAL,
                checked: isPersonalHighlighted,
                className:
                  this.state.highlightPaymentType === PAYMENT_TYPE.PERSONAL &&
                  'checkedLabel',
              },
              {
                label: purchaseLabel,
                id: 'purchaseLabel',
                'data-testid': 'purchase',
                value: PAYMENT_TYPE.PURCHASE,
                checked: isPurchaseHighlighted,
                className:
                  this.state.highlightPaymentType === PAYMENT_TYPE.PURCHASE &&
                  'checkedLabel',
              },
            ]}
          />
          <div className={canChooseWhoPays ? '' : 'hide'}>
            <RadioGroup>
              <Radio
                label={i18nPaymentType('purchaseProtection.tPBRadioSellerPays')}
                value="sellerPaysFee"
                onChange={this.handleFeeOption}
                checked={this.state.whoPaysFee === 'sellerPaysFee'}
                data-testid="sellerPaysFee"
              />
              <Radio
                label={i18nPaymentType(
                  'purchaseProtection.tPBRadioSenderPays',
                  { protectionFee: this.props.fee }
                )}
                onChange={this.handleFeeOption}
                checked={this.state.whoPaysFee === 'senderPaysFee'}
                data-testid="senderPaysFee"
                value="senderPaysFee"
              />
            </RadioGroup>
          </div>

          <CaptionText
            as="aside"
            className={`note-content ${shouldShowNote ? '' : 'hide'}`}
          >
            {noteContent}
          </CaptionText>
          <div
            className={`footer-buttons {isSomethingHighlighted ? '' : 'hide'}`}
          >
            <Button
              onClick={this.handleSubmit}
              value={this.state.highlightPaymentType}
              className={'continue-btn'}
              data-nemo="continue-btn"
            >
              {i18nPaymentType('main.continue')}
            </Button>
            <BodyText strong>
              <PurchaseProtection
                text={i18nPaymentType(
                  'purchaseProtection.protectionEligibility'
                )}
              />
            </BodyText>
          </div>
        </PaymentTypesToggle>
      </div>
    )
  }
}

export default connect(({ server, transaction, recipient, amount, user }) => ({
  transaction: transaction.isPurchase,
  whoPaysFee: transaction.whoPaysFee,
  overpanelType: recipient.moneyPageOverPanel,
  highlightPaymentType: recipient.highlightPaymentType,
  recommendedPaymentType: recipient.recommendedPaymentType,
  triggerSenderPhoneConfirmation:
    server.triggerSenderPhoneConfirmation ||
    user.triggerSenderPhoneConfirmation,
  displayName: recipient.displayName,
  thumbnailUrl: recipient.thumbnailUrl,
  amount: amount.amount,
  currencyCode: amount.currencyCode,
  recipient: recipient.recipient,
  payerId: recipient.payerId,
  isPurchase: transaction.isPurchase,
  moneyPageOverPanel: recipient.moneyPageOverPanel,
  suggestedDesign: recipient.suggestedDesign,
  isPersonalDisabled: user.isPersonalDisabled,
  isPurchaseDisabled: user.isPurchaseDisabled,
}))(PaymentTypeChoice)
